export enum Document {
  POLICY = 'Policy',
  RENEWAL_NOTICE = 'Renewal Notice',
  PA_TAXDEDUCT = 'Tax Deduction',
  CLAIM_NOTI = 'Claim Notification'
}
